import { Component, OnInit, OnDestroy } from '@angular/core';
import { Bank } from '../bank';
import { Location } from '@angular/common';
import { BankService } from '../../../shared/services/bank.service';
import { Subscription } from 'rxjs/Subscription';
import { TdDialogService } from '@covalent/core';
import { ActivatedRoute, ParamMap } from '@angular/router';
import { AuthenticationService } from '../../../shared/services/authentication.service';

@Component({
  selector: 'app-account-deposit',
  templateUrl: './account-deposit.component.html',
  styleUrls: ['./account-deposit.component.scss'],
  providers: [BankService]
})
export class AccountDepositComponent implements OnInit, OnDestroy {
  subscription: Subscription = new Subscription();
  account: Bank = new Bank();
  description: string;
  amount: number;
  date: string;
  _creating: boolean = false;

  constructor(private _location: Location,
    private _bankService: BankService,
    private route: ActivatedRoute,
    public _authService: AuthenticationService,
    private _dialog: TdDialogService) { }

  ngOnInit() {
    this.date = new Date().toISOString().substr(0, 10);

    this.subscription.add(
      this.route.paramMap.subscribe(
        (params: ParamMap) => {
          this.subscription.add(
            this._bankService.getOneBank(params.get('id')).subscribe(
              response => {
                if (response && Array.isArray(response) && response.length > 0) this.account = response[0];
              },
              error => this._dialog.openAlert({ title: 'Error', message: 'Could not retrieve bank data' })
            )
          );
        }
      )
    );
  }

  ngOnDestroy() {
    if (this.subscription) {
      this.subscription.unsubscribe();
    }
  }

  createDeposit() {

    // if not the same year or not the same month, ask for confirmation
    if (this.date.substr(0, 4) !== new Date().toISOString().substr(0, 4)
      || this.date.substr(5, 2) !== new Date().toISOString().substr(5, 2)) {

      this._dialog.openConfirm(
        {
          title: 'Confirm Action',
          message: 'The date you have selected is for a different month, are you sure the date is correct?'
        }
      ).afterClosed().subscribe(
        result => {
          if (result) {

            this.doCreate();
          }
        }
      );
    } else {

      this.doCreate();
    }
  }

  doCreate() {
    this._creating = true;

    this.subscription.add(
      this._bankService.deposit(this.account.id, this.description, this.amount, this.date).subscribe(
        response => {
          if (response && response['status'] == 'SUCCESS') {
            this._dialog.openAlert({ title: 'Success', message: 'Deposit successfully saved' }).afterClosed().subscribe(
              () => {
                this.goBack();
                this._creating = false;
              }
            );
          } else {
            this._dialog.openAlert({ title: 'Error', message: 'Error when creating deposit' });
            this._creating = false;
          }
        }
      )
    );
  }

  goBack() {
    this._location.back();
  }

}



// WEBPACK FOOTER //
// /home/mysticerp/domains/mysticerp.ro/public_html/mystic/agatexfe/src/app/agatextscreens/accounting/account-deposit/account-deposit.component.ts